export default __webpack_public_path__ + "static/media/featured_tour_05.405533be.png";